import { CONSULTATION_COPY } from '../../../constants/consultation';

export const FIELD_IDS = {
  avatar: 'Uf5t1LoiYsc9z5teLXBr',
  bio: '5TMXInKVCGOH7ebdmGWJ',
  specialties: '4VbTdvwhnXbJWflbnzbR',
  education: '72YvUv3uNIHc50dIRxxy',
  certifications: 'AHGCjW37HTiseAtrBIXJ',
  memberships: 'OhYinWFByYhS3pXPDqGg',
  languages: 'pW8Ln9ze5MK0ZZOHfAjF',
  website: '9I1sftRRnWuBrMS8ShKT',
  linkedin: 'XphtFHqlUsGxXUUjD8Rn',
  instagram: 'wsiKmxX94iYdpazxoKMj',
  twitter: 'TI24X9e4rOPXUIRN8HvC',
  facebook: 'F3MBK5L489uU6vclaHfJ',
  experience: '6q2EnpHBpDn8XraVZGGQ',
  businessName: 'jy89qbpujNHkC900L2rV',
  streetAddress: 'WTPws4NQ6aoWgzYcptrj',
  hourlyRate: 'h1ZGKug53NHxS7cwcVcY',
  coverPicture: 'I4U03ywjQCsaqYu1GR3n',
  licensed: 'GnG3hUZHEPZAxKmX2gZ7',
  acceptInsurance: 'iTyKZSnh8G1CDuTSIlOs',
};

export const TEXTS = {
  loading: 'Loading practitioner details...',
  error: {
    title: 'Error Loading Practitioner',
    description: 'Unable to fetch practitioner data',
    button: 'Go Back',
  },
  notFound: {
    title: 'Practitioner Not Found',
    button: 'Go Back',
  },
  hero: {
    backToHome: 'Back to Home',
    specialtiesLabel: 'Specialties:',
    checkingPayment: '🔄 Checking payment status...',
    paymentVerified: '✅ Payment method verified:',
    expires: 'Expires:',
    verifyPayment: '⚠️ Please verify your payment method to book a consultation',
    bookConsultation: CONSULTATION_COPY.book,
    verifyToBook: 'Verify Payment to Book →',
    checking: 'Checking...',
  },
  bookingStatus: {
    assigning: '🔄 Assigning you to',
    calendarOpen: '📅 Calendar window is open...',
  },
  personalStory: {
    title: 'About the Name',
  },
  biography: {
    getTitle: (firstName) => `About ${firstName}`,
    subtitle: 'Get to know your certified hypnotherapist',
  },
  credentials: {
    title: 'Professional Credentials',
    education: 'Education',
    certifications: 'Certifications',
    memberships: 'Professional Memberships',
    practitionerTypes: 'Practitioner Types',
    languages: 'Languages Spoken',
  },
  contact: {
    title: 'Contact Information',
    email: 'Email:',
    phone: 'Phone:',
    address: 'Address:',
    visitWebsite: 'Visit Website',
    noData: 'Contact information coming soon.',
  },
};
